import { AAMembersListFilters } from '../../../styledComponents/ProductMembersList/AAMembersList/AAMembersFilters/aaMembersFilters.models';

export const pageFilters = [
  AAMembersListFilters.Search,
  AAMembersListFilters.Plan,
  AAMembersListFilters.MemberType,
  AAMembersListFilters.RenewStatus,
];
